import axios from 'axios'
import {
  getCustomList,
  testFunction
} from "../../../api";

const state = {

}

const mutations = {
  // get custom list
  async getCustomList (state2, payload) {
    console.log('getCustomList: ', payload)
    // parse payload
    let customList = payload.customList
    let limit = payload.limit
    let startAt = payload.startAt
    let isFirstQuery = payload.isFirstQuery
    // call api
    let response = await axios.get(`${getCustomList}`, {
      params: {
        customList,
        limit,
        startAt,
        isFirstQuery
      }
    })
    // console.log('gotCustomList: ', response)
    let data = response.data
    // console.log('gotCustomList: ', data)
    // all data.
    if (data.size != 0) {
      // last queried data.
      let lastQueried = data.docs[data.docs.length-1]
      console.log('lastQueried: ', lastQueried)
      // see all data.
    }
  },
  // test function
  async testFunction (state, payload) {
    // console.log('testFunction', payload)
    let response = await axios.get(`${testFunction}`)
    // console.log('gotFromTestFunction', response)
    let data = response.data
    // console.log('COMPARE: ', data)
    data.forEach((doc)=>{
      // console.log('1: ', doc.id)
      // console.log('2: ', doc.data())
    })
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/customList/customList.js